import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ProofService from 'services/paymentProofService';

export const submitProof = createAsyncThunk(
    'proof/submitProof',
    async (formData, { rejectWithValue }) => {
        try {
            console.log("submitProof : ", formData);

            const response = await ProofService.submitProof(formData);
            console.log("submitProof resp : ", response);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);

const initialState = {
    loading: false,
    data: null,
    error: null
};

const proofSlice = createSlice({
    name: 'proof',
    initialState,
    reducers: {
        resetProofState: () => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(submitProof.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(submitProof.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(submitProof.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { resetProofState } = proofSlice.actions;
export default proofSlice.reducer;
